import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { TYPE_LABELS, formatViews } from '@/utils/movie';

interface MovieListItemProps {
  movie: Movie;
}

export default function MovieListItem({ movie }: MovieListItemProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 hover:bg-background-100 md:p-4"
    >
      <div className="relative h-[132px] w-[88px] shrink-0 overflow-hidden rounded-md bg-background-200 md:h-[168px] md:w-[112px]">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 丝瓜视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-1.5 top-1.5 flex items-center gap-0.5 rounded bg-accent-500/95 px-1.5 py-0.5 font-label text-[11px] font-bold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-2">
          <h3 className="line-clamp-1 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
            {movie.title}
          </h3>
        </div>
        <p className="mt-1 text-xs text-foreground-500 md:text-sm">
          {TYPE_LABELS[movie.type]} · {movie.year} · {movie.region}
        </p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:line-clamp-3 md:text-sm">
          {movie.synopsis}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-3">
          {movie.genres.map((g) => (
            <span key={g} className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
              {g}
            </span>
          ))}
          <span className="ml-auto inline-flex items-center gap-1 text-[11px] text-foreground-400">
            <i className="ri-fire-line" /> {formatViews(movie.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}